/* NOTE: history.state.idx keeps track of the index of history events in the Next app. The contents of window.history.state is managed by Next and idx is a Next property.
 * This means any browser history before arriving at the app will not be taken into account. This is useful for webview as it is launched in the native app and we want to exclude any
 * previous history e.g. ULA login screen or landing pages. IDX is an undocumented property and so we want to default to normal back behaviour if it no longer exists for some reason
 */

import { NextRouter, useRouter } from 'next/router';

function getHasInternalHistory() {
  if (typeof window?.history?.state?.idx === 'undefined') return true;
  return window.history.state.idx > 0;
}

export default function useOnInternalOnlyBack(): NextRouter['back'] {
  const router = useRouter();
  const hasInternalHistory = getHasInternalHistory();

  if (hasInternalHistory) {
    return router.back;
  }
  return null;
}
